/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Screens_QuestionInputs */

const en_onboarding_screens_question = /** @type {(inputs: Onboarding_Screens_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is reading on screens physically difficult?`)
};

const es_onboarding_screens_question = /** @type {(inputs: Onboarding_Screens_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es físicamente difícil leer en pantallas?`)
};

/**
* | output |
* | --- |
* | "Is reading on screens physically difficult?" |
*
* @param {Onboarding_Screens_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_screens_question = /** @type {((inputs?: Onboarding_Screens_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Screens_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_screens_question(inputs)
	return en_onboarding_screens_question(inputs)
});